import React from 'react'
import { HubTable } from 'components/HubDefaultTable'
import { showModal } from 'components/popup'
import {
  TableScrollWrapper,
  ConnectionCardList,
  ConnectionCard,
  CardHeader,
  CardStartupLink,
  CardBadge,
  CardRow,
  CardLabel,
  CardValue
} from '../index.style'

export interface CompleteConnectionItem {
  startup: string
  description: string
  responsible: string
  interestArea: string
  metWeb: string
  startDate: string
  lastUpdate: string
}

export interface HubStartupCompleteConnectionsTableProps {
  items: CompleteConnectionItem[]
}

const MONTHS_PT_SHORT = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    return ''
  }
  const day = String(date.getDate()).padStart(2, '0')
  const month = MONTHS_PT_SHORT[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${month} ${String(year)}`
}

export const HubStartupCompleteConnectionsTable = ({ items }: HubStartupCompleteConnectionsTableProps): JSX.Element => {
  const header = [
    'Startup',
    'Responsável pela conexão',
    'Área de interesse',
    'Como conheceu',
    'Data de início',
    'Última atualização'
  ]
  const rows = items.map((item) => [
    (
      <span
        key={`${item.startup}-link`}
        role='button'
        onClick={() => showModal('connectionData', {
          source: item.metWeb,
          responsible: item.responsible,
          areaInterest: item.interestArea,
          description: item.description
        })}
        style={{
          textDecorationLine: 'underline',
          textDecorationStyle: 'solid',
          textDecorationSkipInk: 'none',
          textDecorationThickness: 'auto',
          textUnderlineOffset: 'auto',
          textUnderlinePosition: 'from-font',
          cursor: 'pointer'
        }}
      >
        {item.startup}
      </span>
    ),
    item.responsible,
    item.interestArea,
    item.metWeb,
    formatDate(item.startDate),
    formatDate(item.lastUpdate)
  ])

  const headerSize = ['18%', '20%', '18%', '16%', '14%', '14%']

  return (
    <>
      <TableScrollWrapper>
        <HubTable header={header} rows={rows} headerSize={headerSize} />
      </TableScrollWrapper>
      <ConnectionCardList>
        {items.map((item, index) => (
          <ConnectionCard key={index}>
            <CardHeader>
              <CardStartupLink
                role='button'
                onClick={() => showModal('connectionData', {
                  source: item.metWeb,
                  responsible: item.responsible,
                  areaInterest: item.interestArea,
                  description: item.description
                })}
              >
                {item.startup}
              </CardStartupLink>
              {item.metWeb && <CardBadge>{item.metWeb}</CardBadge>}
            </CardHeader>
            {item.responsible && (
              <CardRow>
                <CardLabel>Responsável:</CardLabel>
                <CardValue>{item.responsible}</CardValue>
              </CardRow>
            )}
            <CardRow>
              <CardLabel>Área de interesse:</CardLabel>
              <CardValue>{item.interestArea}</CardValue>
            </CardRow>
            <CardRow>
              <CardLabel>Data de início:</CardLabel>
              <CardValue>{formatDate(item.startDate)}</CardValue>
            </CardRow>
            <CardRow>
              <CardLabel>Última atualização:</CardLabel>
              <CardValue>{formatDate(item.lastUpdate)}</CardValue>
            </CardRow>
          </ConnectionCard>
        ))}
      </ConnectionCardList>
    </>
  )
}